<div class="property-side-card">
    <tg-card>
        <tg-row class="property-side-card__heading">
            <tg-col lg="3" class="property-side-card__heading-image">
                <img [src]="icon" />
            </tg-col>
            <tg-col lg="9" md="12" class="property-side-card__heading-text">
                <h5>
                    {{ heading }}
                </h5>
            </tg-col>
        </tg-row>
        <tg-row class="property-side-card__body">
            <p class="property-side-card__body-text">
                <ng-content></ng-content>
            </p>
        </tg-row>
        <tg-row class="property-side-card__action" *ngIf="callToActionLink && callToActionText">
            <a
                class="property-side-card__body-action-link"
                [href]="callToActionLink"
                target="_blank"
                >{{ callToActionText }}
                <tg-icon
                    class="property-side-card__body-action-icon"
                    name="link-external"
                    size="small"
                    alt="link-external"
                ></tg-icon
            ></a> </tg-row
    ></tg-card>
</div>
